import {
  GUIDED_SELLING_QUESTION1,
  GUIDED_SELLING_QUESTION2
} from "../../config/tags";
import { PREMIUM_PRODUCT, CORE_PRODUCT } from "./constants";

export const resultsFunction = (answers, questions) => {
  const gsQuestion1Ids = questions
    .filter(q => q.tags.includes(GUIDED_SELLING_QUESTION1))
    .map(q => q?._id);
  const gsAnswer1 = answers.find(a => gsQuestion1Ids.includes(a.questionId));
  const gsQuestion2Ids = questions
    .filter(q => q.tags.includes(GUIDED_SELLING_QUESTION2))
    .map(q => q?._id);
  const gsAnswer2 = answers.find(a => gsQuestion2Ids.includes(a.questionId));

  const firstAnswer = gsAnswer1?.answers[0].value;
  const secondAnswer = gsAnswer2?.answers[0].value;

  if (firstAnswer === "D" && secondAnswer === "W") {
    return PREMIUM_PRODUCT;
  }
  if (firstAnswer === "V" && secondAnswer === "W") {
    return PREMIUM_PRODUCT;
  }
  if (firstAnswer === "W" && secondAnswer === "V") {
    return PREMIUM_PRODUCT;
  }
  if (firstAnswer === "W" && secondAnswer === "W") {
    return PREMIUM_PRODUCT;
  }

  return CORE_PRODUCT;
};

export const checkIsPremium = (answers, questions) => {
  const result = resultsFunction(answers, questions);

  if (result === PREMIUM_PRODUCT) {
    return true;
  }

  return false;
};
